import styled from 'styled-components';

const CardLogo = styled.img`
width: 400px;
height: 230px;
border-radius : 0px 0px 0px 8px;
@media screen and (max-width:1000px){
    width: 400px;
    height: 25vh;
  }
`;

export default CardLogo;
